// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15Iz8","col":"styles_col__3nic_"};